import React, { useContext } from 'react';
import TableData from '../TableData';
import Checkbox from '../../checkbox/Checkbox';
import { Row } from '../component/types';
import { TableContext } from './provider/Provider';

interface Props<T> {
  row: T;
  index: number;
}

function CheckItem<T extends Row>({ row, index }: Props<T>) {
  const { selectedIdsData, onClickCheckbox } = useContext(TableContext);
  return (
    <TableData className="specific">
      <Checkbox
        id={`all[${row?.id || index}]`}
        name={`all[${row?.id || index}]`}
        controlling
        value={(row?.id || index) as string}
        checked={selectedIdsData.selectedIds?.includes(
          (row?.id as never) || index,
        )}
        onChange={() => onClickCheckbox(row?.id || index)}
      />
    </TableData>
  );
}

export default CheckItem;
